<template>
    <div class="card">
        <div class="card-body m-2">
            <div class="row p-2 mb-3">
                <div class="d-row d-flex align-items-center">


                    <div class="col-3">
                        <input type="text" class="form-control form-control-sm rounded-pill"
                            placeholder="&#xF002; Search/Add Allowed Domains/IPs..." @keyup="onSearch()"
                            v-on:keyup.enter="onEnter" v-model="inputAllowed"
                            style="font-size: 15px; font-family: 'Roboto', sans-serif, 'Font Awesome 6 Free';" />
                    </div>

                    <div class="ms-2 col-3 button-container">
                        <button type="button" class="fw-bold btn btn-info-outline rounded-pill btn-sm" @click="sendData"
                            style="font-size: 15px; width: 200px;">
                            <i class="fa-regular fa-list-check"></i>
                            + Allow Domain or IP
                        </button>
                    </div>

                    <!-- FILTERS -->
                    <div class="col-6 d-flex flex-row justify-content-end">

                        <div class="d-flex flex-row align-items-center">
                            <span class="p-2 filter-title">Sort by:</span>
                            <select v-model="sortBy" class="form-select shadow-none filter-options"
                                style="width:auto;border:none">
                                <option v-for="sortBy in sortByList" :value="sortBy.value" :key="sortBy.value">{{
                                    sortBy.text }}
                                </option>
                            </select>
                        </div>

                        <div class="d-flex flex-row align-items-center">
                            <span class="p-2 filter-title">Rows Per Page:</span>
                            <select v-model="pagination.pageSize"
                                class="form-select form-select-sm shadow-none filter-options">
                                <option v-for="row in rowsPerPageList" :value="row.value" :key="row.value">{{ row.text
                                    }}
                                </option>
                            </select>
                        </div>

                    </div>

                    <!-- <div>
                        <input type="text" class="form-control form-control-sm rounded-start-pill"
                            placeholder="&nbsp;Add/Search Allow Website..." style="font-size: 14px; width: 500px; 
                    font-family: 'Roboto', sans-serif, 'Font Awesome 6 Free';" v-model="inputAllowed"
                            v-on:keyup.enter="onEnter" @keyup="onSearch()" ref="allow_list_ref" />
                    </div>

                    <div class="ms-2">
                        <button type="button" class="fw-bold btn btn-info-outline rounded-pill btn-sm"
                            style="font-size: 14px; width: 100px;" @click="sendData">
                            <i class="fa-regular fa-list-check"></i>
                            + Allow Domain
                        </button>
                    </div> -->

                </div>
            </div>

            <div class="row p-2">
                <div class="table-responsive">
                    <table class="table align-middle">

                        <thead class="align-middle">
                            <tr>
                                <th scope="col" v-for="header in headers" :key="header.value">{{ header.text }}</th>
                            </tr>
                        </thead>

                        <tbody v-if="this.pagination.totalItems <= 0">
                            <tr>
                                <td colspan="4">
                                    No records to display.
                                </td>
                            </tr>
                        </tbody>

                        <tbody>
                            <tr v-for="(allowedWebsite, index) in allowedWebsites" :key="index">
                                <td>{{ allowedWebsite.domain }}</td>
                                <td>
                                    <div class="form-check form-switch">
                                        <input
                                            class="form-check-input form-control form-custom-check-input form-custom-check-size border-success hand-cursor"
                                            type="checkbox" id="flexSwitchCheckChecked"
                                            @click="updateAllowUpload(index)" :checked="allowedWebsite.allow_upload">
                                    </div>

                                    <!-- <input class="form-check-input" type="checkbox" value="" id="flexCheckChecked"
                               @click="updateAllowUpload(index)" :checked="allowedWebsite.allow_upload"> -->
                                </td>
                                <td>
                                    <div class="form-check form-switch">
                                        <input
                                            class="form-check-input form-control form-custom-check-input form-custom-check-size border-success hand-cursor"
                                            type="checkbox" id="flexSwitchCheckChecked" @click="updateAllowHttp(index)"
                                            :checked="allowedWebsite.allow_http">
                                    </div>

                                    <!-- <input class="form-check-input" type="checkbox" value="" id="flexCheckChecked"
                               @click="updateAllowUpload(index)" :checked="allowedWebsite.allow_upload"> -->
                                </td>
                                <td> <button type="button" class="btn btn-circle-trash" data-bs-toggle="modal"
                                        @click="deleteAllowedSite(index)"><span><i
                                                class="fa fa-trash"></i></span></button></td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>

            <!-- START -- PAGINATION -->
            <div class="row text-center">

                <div class="d-inline pagination">
                    <a @click="previousPage()" style="margin-right: 8px; color: #00a0c1;"
                        :style="this.pagination.page == 1 ? 'color: #ccc;' : 'cursor: pointer;'"
                        :disabled="this.pagination.page == 1">
                        <i class="fa fa-chevron-left"></i>
                    </a>
                    <span>
                        <strong>
                            <span> {{ paginationLabel }} of {{ this.pagination.totalItems }} </span>
                        </strong>
                    </span>
                    <a @click="nextPage()" style="margin-left: 8px; color: #00a0c1;" :style="this.pagination.page == this.pagination.totalPages
                        || this.pagination.totalItems == 0 ? 'color: #ccc;' : 'cursor: pointer;'"
                        :disabled="this.pagination.page == this.pagination.totalPages || this.pagination.totalItems == 0">
                        <i class="fa fa-chevron-right"></i>
                    </a>
                </div>

            </div>
            <!-- END -- PAGINATION -->

        </div>
    </div>
</template>

<script>
import { debounce, IsValidIPV4, ExtractDomain } from '@/plugins/helper.js'
export default {

    components: {

    },

    data() {
        return {
            headers: [
                { text: "Domain", value: "domain" },
                { text: "Upload Allowed", value: "allow_upload" },
                { text: "HTTP Allowed", value: "allow_http" },
                { text: "Actions", value: "actions" },
            ],
            debounceFn: null,
            allowedWebsites: [],
            inputAllowed: "",
            isIPToggled: false,
            isModalOpen: false,
            paginationData: {},
            pagination: {
                pageSize: 50,
                page: 1,
                totalItems: 0,
                totalPages: 1,
            },
            rowsPerPageList: [
                { text: "50", value: 50 },
                { text: "75", value: 75 },
                { text: "100", value: 100 },
            ],
            sortByList: [
                { text: "Date: Newest", value: "date_created__desc" },
                { text: "Date: Oldest", value: "date_created__asc" },
                { text: "Domain: A-Z", value: "domain__asc" },
                { text: "Domain: Z-A", value: "domain__desc" },
            ],
            sortBy: "domain__asc", //default option
            sorting: {
                field: "domain",
                order: "asc"
            },
        };

    },

    computed: {
        paginationLabel() {
            var start = Math.min((this.pagination.page - 1) * this.pagination.pageSize + 1, this.pagination.totalItems)
            var end = Math.min((this.pagination.page * this.pagination.pageSize), this.pagination.totalItems)

            return start + " - " + end
        },

        currentPage() {
            return this.pagination.page
        },

        rowsPerPage() {
            return this.pagination.pageSize
        },

        sortItems() {
            return this.sortBy
        },
    },

    watch: {
        currentPage() {
            this.getAllowList()
        },

        rowsPerPage() {
            this.pagination.page = 1
            this.getAllowList()
        },

        sortItems() {
            if (this.sortBy.includes("__")) {
                let sort = this.sortBy.split("__")
                this.sorting.field = sort[0]
                this.sorting.order = sort[1]
            } else {
                this.sorting.field = this.sortBy
                this.sorting.order = ""
            }
            this.getAllowList()
        },
    },

    mounted() {
        this.init();
    },

    created() {
        this.debounceFn = debounce(() =>
            this.getAllowList()
            , 500)
    },

    methods: {

        init() {
            this.getAllowList()
        },

        onSearch() {
            this.debounceFn()
        },

        openConfirmationModal() {
            this.isModalOpen = true;
        },
        closeConfirmationModal() {
            this.isModalOpen = false;
        },
        deleteItem() {
            // Perform the delete operation
            // ...

            this.closeConfirmationModal();
        },

        previousPage() {
            this.pagination.page > 1 ? this.pagination.page -= 1 : ''
        },

        nextPage() {
            this.pagination.totalPages > this.pagination.page ? this.pagination.page += 1 : ''
        },

        onEnter: function () {
            this.sendData()
        },

        async sendData() {
            try {

                //)
                let domLen = this.inputAllowed.length
                let eDomain = ""

                if(this.inputAllowed == null || this.inputAllowed == "") {
                    this.$toast.error("Please provide a valid domain or IP.")
                    return
                }

                let validIP = IsValidIPV4(this.inputAllowed)
                let validDomain = false

                if (!validIP) {
                    if (this.inputAllowed[domLen - 1] == '/') {
                        this.inputAllowed = this.inputAllowed.substring(0, domLen - 1)
                    }

                    eDomain = ExtractDomain(this.inputAllowed)
                    if (eDomain != null || eDomain != "") {
                        if (eDomain.includes("www.")) {
                            eDomain = eDomain.replace("www.", "")
                        }
                    }

                    validDomain = this.isValidDomain(eDomain)
                }


                if(!validIP && !validDomain) {
                    this.$toast.error("Please provide a valid domain or IP.")
                    return
                } else {
                    if(validIP) {
                        eDomain = this.inputAllowed
                    } else if(this.isValidDomain(eDomain)) {
                        eDomain = ExtractDomain(this.inputAllowed)
                    }
                }


                // if (!IsValidIPV4(this.inputAllowed)) {
                   

                //     if (eDomain != null || eDomain != "") {
                //         if (eDomain.includes("www.")) {
                //             eDomain = eDomain.replace("www.", "")
                //         }
                //     }

                //     if ((this.inputAllowed == "" || this.inputAllowed == null) && this.isValidDomain(eDomain) == false) {
                //         this.$toast.error("Please provide a valid domain.")
                //         return
                //     }
                // } else if (IsValidIPV4(this.inputAllowed)) {
                //     eDomain = this.inputAllowed
                // } else {
                //     if ((this.inputAllowed == "" || this.inputAllowed == null) && this.isValidDomain(eDomain) == false && !IsValidIPV4(this.inputAllowed)) {
                //         this.$toast.error("Please provide a valid domain.")
                //         return
                //     }
                // }

                const payload = {
                    domain: eDomain,
                    allow_upload: 1
                }


                const resp = await this.$axios.post("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/add-account-allow-site", payload)

                if (resp.data.success != null && resp.data.success == false) {
                    this.$toast.error(resp.data.message)
                    this.inputAllowed = ""
                    this.getAllowList()
                } else {
                    this.$toast.success(resp.data.message)
                    this.inputAllowed = ""
                    this.getAllowList()
                }

            } catch (error) {
                console.log(error)
                this.$toast.error("An error has occured.")
                this.inputAllowed = ""
                this.getAllowList()
            }
        },

        async getAllowList() {

            let apiPath = "extension-configuration/" + this.$store.state.auth.organisation_uuid + "/get-account-allow-list?page_size=" + this.pagination.pageSize + "&page=" + this.pagination.page

            if (this.sorting.order != "" && this.sorting.field != "") {
                apiPath += "&sort_by=" + this.sorting.field
                apiPath += "&order_by=" + this.sorting.order
            }

            if (this.inputAllowed !== "" || this.inputAllowed !== null) {
                apiPath += "&search_key=" + this.inputAllowed
            }


            await this.$axios.get(apiPath).
                then((response) => {
                    if (response.data.allow_list === "No Record Found")
                        this.allowedWebsites = []
                    else {
                        this.allowedWebsites = response.data.allow_list
                    }

                    this.paginationData = response.data.pagination
                    this.pagination.totalItems = this.paginationData.total_count
                    this.pagination.totalPages = Math.ceil(this.paginationData.total_count / this.pagination.pageSize)
                })
                .catch((error) => {
                    console.log(error)
                    this.$toast.error(error)
                })

        },

        async deleteAllowedSite(index) {
            try {


                console.log(this.allowedWebsites[index])

                const payload = {
                    domain: this.allowedWebsites[index].domain,
                    id: this.allowedWebsites[index].id
                }

                const resp = await this.$axios.delete("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/remove-account-allow-site/" + this.allowedWebsites[index].id, payload)

                if (resp.data.success != null && resp.data.success == false) {
                    this.$toast.error(resp.data.message)
                } else {
                    this.$toast.success(resp.data.message)
                    this.getAllowList()
                }

            } catch (error) {
                console.log(error)
                this.$toast.error("An error has occured.")
            }
        },

        async updateAllowUpload(index) {
            try {


                //console.log(this.allowedWebsites[index])

                const payload = {
                    id: this.allowedWebsites[index].id
                }

                const resp = await this.$axios.patch("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/update-allow-upload", payload)

                if (resp.data.success != null && resp.data.success == false) {
                    this.$toast.error(resp.data.message)
                } else {
                    this.$toast.success(resp.data.message)
                    this.getAllowList()
                }

            } catch (error) {
                console.log(error)
                this.$toast.error("An error has occured.")
            }
        },

        async updateAllowHttp(index) {
            try {


                console.log(this.allowedWebsites[index])

                const payload = {
                    id: this.allowedWebsites[index].id
                }

                const resp = await this.$axios.patch("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/update-allow-http", payload)

                if (resp.data.success != null && resp.data.success == false) {
                    this.$toast.error(resp.data.message)
                } else {
                    this.$toast.success(resp.data.message)
                    this.getAllowList()
                }

            } catch (error) {
                console.log(error)
                this.$toast.error("An error has occured.")
            }
        },

        isValidDomain(domain) {
            const domainPattern = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            return domainPattern.test(domain);
        },

        extractDomain(url) {
            try {
                if (this.isValidDomain(url))
                    return url

                let parsedURL = new URL(url);
                let domain = parsedURL.hostname;
                return domain;
            } catch (err) {
                if (err) {
                    console.log(err)
                    return ""
                }
            }
        }
    }

}

</script>

<style scoped>
.card {
    border: none;
}

.card-title {
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    color: #435666;
}

.form-check-input:checked {
    background-color: rgba(25, 135, 84, 1.0);
    border-color: rgba(25, 135, 84, 1.0);
}

.form-custom-check-input {
    opacity: 0.7;
    width: 5em !important;
}

.form-custom-check-size {
    min-height: calc(1.1em + 1rem + 2px);
    padding: 0.5rem 1rem;
    font-size: 0.8em;
    border-radius: 1rem;
}

.form-control-max-width {
    max-width: 25rem;
}

.inputbox-padding {
    padding-left: 5rem;
}

.table {
    border: 0px 0px 1px 0px;
    font-size: 15px
}


/* additional styles */

/* button {
     border-radius: 40px !important;
 } */

.btn-info {
    background-color: #00a0c1;
    border-color: #00a0c1;
}

.btn-info:focus,
.btn-info:hover,
.btn-info:active {
    background-color: #00a0c1;
    border-color: #00a0c1;
    opacity: 0.9
}

.btn-info:disabled {
    background-color: #00343f;
    border-color: #00343f;
}

.btn-outline-info {
    color: #00a0c1;
    border-color: #00a0c1;
}

.btn-outline-info:focus,
.btn-outline-info:hover,
.btn-outline-info:active {
    color: #fff;
    background-color: #00a0c1;
    border-color: #00a0c1;
}


.btn-warning {
    background-color: #F3994D;
    border-color: #F3994D;
}

.btn-warning:hover {
    background-color: #F3994D;
    border-color: #F3994D;
    opacity: 0.9
}

.btn-outline-warning {
    color: #F3994D;
    border-color: #F3994D;
}

.btn-outline-warning:hover {
    color: #fff;
    background-color: #F3994D;
    border-color: #F3994D;
}

.btn-circle {
    width: 30px;
    height: 30px;
    padding: 6px 0px;
    border-radius: 15px;
    text-align: center;
    font-size: 12px;
    line-height: 1.42857;
    border: 1px solid #00A0C1;
    color: #00A0C1;
}


.btn-circle-trash {
    width: 30px;
    height: 30px;
    padding: 6px 0px;
    border-radius: 15px;
    text-align: center;
    font-size: 12px;
    line-height: 1.42857;
    border: 1px solid #EB1C24;
    color: #EB1C24;
}

.btn-circle-trash:hover {
    border: 1px solid #EB1C24;
    color: whitesmoke;
    background-color: #EB1C24;
}

.btn-circle:hover {
    border: 1px solid #00A0C1;
    color: #00A0C1;
}

.btn-circle:focus {
    border: 1px solid #00A0C1;
    color: #00A0C1;
}

.btn-circle-danger {
    width: 30px;
    height: 30px;
    padding: 6px 0px;
    border-radius: 15px;
    text-align: center;
    font-size: 12px;
    line-height: 1.42857;
    border: 1px solid #EB1C24;
    color: #EB1C24;
}

.btn-circle-danger:hover {
    border: 1px solid #EB1C24;
    color: #EB1C24;
}

.btn-circle-danger:focus {
    border: 1px solid #EB1C24;
    color: #EB1C24;
}

.hand-cursor {
    cursor: pointer;
}


/* additional */
.btn-info-outline {
    background-color: white;
    border-color: #00a0c1;
    color: #00a0c1;
}

.btn-info-outline:hover {
    background-color: #00a0c1;
    border-color: #00a0c1;
    color: whitesmoke;
}

.btn-info-outline-active {
    background-color: #00A54F;
    border-color: #00A54F;
    color: whitesmoke;
}

.btn-info:focus,
.btn-info:hover,
.btn-info:active {
    background-color: #00a0c1;
    border-color: #00a0c1;
    opacity: 0.9
}

.btn-info:disabled {
    background-color: #00343f;
    border-color: #00343f;
}

.btn-outline-info {
    color: #00a0c1;
    border-color: #00a0c1;
}

.btn-outline-info:focus,
.btn-outline-info:hover,
.btn-outline-info:active {
    color: #fff;
    background-color: #00a0c1;
    border-color: #00a0c1;
}

.table-responsive {
    overflow: auto;
    /* max-height: 50vh; */
    max-height: 600px;
}

/* table thead, th {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1; 
    background: #fff;
} */
</style>